import { useSetAtom } from "jotai";
import { useEffect } from "react";

import { useAdvertisementCampaignConfig } from "scmp-app/components/advertisement/campaign/hooks";
import { useAdvertisementConfig } from "scmp-app/components/advertisement/hooks";
import { appAtom } from "scmp-app/lib/app/atoms";
import { useNavigatorInfo } from "scmp-app/lib/hooks";

export const useAppSetup = () => {
  const setApp = useSetAtom(appAtom);

  const { config: advertisementConfig, loaded: advertisementCampaignConfigLoaded } =
    useAdvertisementConfig();
  const { config: advertisementCampaignConfig, loaded: advertisementConfigLoaded } =
    useAdvertisementCampaignConfig();
  const { data: navigatorInfo, loaded: navigatorInfoLoaded } = useNavigatorInfo();

  useEffect(() => {
    setApp({
      advertisementCampaignConfig,
      advertisementCampaignConfigLoaded,
      advertisementConfig,
      advertisementConfigLoaded,
      navigatorInfo,
      navigatorInfoLoaded,
    });
  }, [
    advertisementCampaignConfig,
    advertisementCampaignConfigLoaded,
    advertisementConfig,
    advertisementConfigLoaded,
    navigatorInfo,
    navigatorInfoLoaded,
    setApp,
  ]);
};
